import { Card, Text, BlockStack } from '@shopify/polaris';
import { t } from '../i18n';
import { AdminLanguageMenu } from './AdminLanguageMenu';

export function AdminLanguageCard() {
  return (
    <Card>
      <BlockStack gap="300">
        <Text as="h2" variant="headingMd">
          {t('Language')}
        </Text>
        <AdminLanguageMenu />
      </BlockStack>
    </Card>
  );
}
